import Indexno from '../components/pages/index-no'
import Indexteacher from '../components/pages/index-teacher'
import Indexstudent from '../components/pages/index-student'
import Login from '../components/pages/login'
import Findteacher from '../components/pages/find-teacher'
import Findstudent from '../components/pages/find-student'
import Personteacher from '../components/pages/personteacher'
import Personstudent from '../components/pages/personstudent'
import Teacherjinali from '../components/pages/teacherjianli'
import Teacherwechat from '../components/pages/teacherwechat'
import Teacherphone from '../components/pages/teacherphone'
import Teacherpwd from '../components/pages/teacherpwd'
import Teacherchuli from '../components/pages/teacherchuli'
import Teachermessage from '../components/pages/tecahermessage'
import Teacherrenzheng from '../components/pages/teacherrenzheng'
import Teacherzhuli from '../components/pages/teacherzhuli'
import TeacherjianliSucces from '../components/pages/teacherjianlisucces'
import Teacherrenzhenging from '../components/pages/teacherrenzhenging'
import Teacherrenzhengsucces from '../components/pages/teacherrenzhengsucces'
// import Teacherzhuliing from '../components/pages/teacherzhuliing'
import Studentmessage from '../components/pages/studentmessage'
import Studentphone from '../components/pages/studentphone'
import Studentpwd from '../components/pages/studentpwd'
import Studenttoudi from '../components/pages/studenttoudi'
import Studentwechat from '../components/pages/studentwechat'
import Studentxuqiu from '../components/pages/studentxuqiu'
import Studentyuyue from '../components/pages/studentyuyue'
import Studentdingdan from '../components/pages/stundentdingdan'
import Studentsend from '../components/pages/studentsend'
import Studentlook from '../components/pages/studentlook'
import Nocounseling from '../components/pages/Nocounseling'
import Scounseling from '../components/pages/Scounseling'
import Tcounseling from '../components/pages/Tcounseling'
import Teacherlook from '../components/pages/Teacherlook'
import Yonghu from '../components/pages/yonghuxieyi'
import Studentyuyueing from '../components/pages/student-yuyue'
import Studentsuccess from '../components/pages/studentsuccess.vue'
export default [
  {
    path: '/indexno',
    name: 'Indexno',
    component: Indexno
  },
  {
    path: '/studentyuyueing',
    component: Studentyuyueing
  },
  {
    path: '/yonghuxieyi',
    component: Yonghu
  },
  {
    path: '/Scounseling',
    name: 'Scounseling',
    component: Scounseling
  },
  {
    path: '/Tcounseling',
    name: 'Tcounseling',
    component: Tcounseling
  }, {
    path: '/Nocounseling',
    name: 'Nocounseling',
    component: Nocounseling
  },
  {
    path: '/indexteacher',
    name: 'Indexteacher',
    component: Indexteacher
  },
  {
    path: '/indexstudent',
    name: 'Indexstudent',
    component: Indexstudent
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    redirect: '/indexno'
  },
  {
    path: '/findteacher',
    name: 'Findteacher',
    component: Findteacher
  },
  {
    path: '/findstudent',
    name: 'Findstudent',
    component: Findstudent
  },
  {
    path: '/teacherlook',
    name: 'Teacherlook',
    component: Teacherlook
  },
  {
    path: '/personteacher',
    name: 'Personteacher',
    component: Personteacher,
    children: [
      { path: 'jianli', component: Teacherjinali },
      { path: 'wechat', component: Teacherwechat },
      { path: 'phone', component: Teacherphone },
      { path: 'pwd', component: Teacherpwd },
      { path: 'zhuli', component: Teacherzhuli },
      // { path: 'zhuliing', component: Teacherzhuliing },
      { path: 'message', component: Teachermessage },
      { path: 'renzheng', component: Teacherrenzheng },
      { path: 'renzhengsucces', component: Teacherrenzhengsucces },
      { path: 'renzhenging', component: Teacherrenzhenging },
      { path: 'chuli', component: Teacherchuli },
      { path: '/', redirect: 'jianli' },
      { path: 'jianlisucces', component: TeacherjianliSucces }
    ]

  },
  {
    path: '/personstudent',
    name: 'Personstudent',
    component: Personstudent,
    children: [
      { path: 'message', component: Studentmessage },
      { path: 'phone', component: Studentphone },
      { path: 'pwd', component: Studentpwd },
      { path: 'toudi', component: Studenttoudi },
      { path: 'wechat', component: Studentwechat },
      { path: 'xuqiu', component: Studentxuqiu },
      { path: 'yuyue', component: Studentyuyue },
      { path: 'dingdan', component: Studentdingdan },
      { path: '/', redirect: 'xuqiu' },
      { path: 'send', component: Studentsend },
      { path: 'success', component: Studentsuccess }

    ]
  },
  {
    path: '/studentlook',
    name: 'Studentlook',
    component: Studentlook
  }

]


// WEBPACK FOOTER //
// ./src/vue-router/pages.js